'use strict';

export default class LoginController {
  user = {
    name: '',
    email: '',
    password: ''
  };
  errors = {
    login: undefined
  };
  submitted = false;


  /*@ngInject*/
  constructor(Auth, $state, $http, $timeout) {
    this.Auth = Auth;
    this.$state = $state;
    this.$http = $http;
    this.$timeout = $timeout;
  }

  login(form) {
    this.submitted = true;

    if(form.$valid) {
      this.Auth.login({
        email: this.user.email,
        password: this.user.password
      })
        .then(() => {
          this.$state.go('procedureStatus');
          // Logged in, redirect to procedureStatus state
          // var fwdPath = this.$state.params.fwdPath;
          //   if (fwdPath != null) {
          //       this.$state.go('timeouts',{id: fwdPath});
          //   } else {
          //
          //   }



        })
        .catch(err => {
          this.errors.login = err.message;
        });
    }
  }

  forgotPassword(form) {
    this.submitted = true;
    console.log(form.$valid);
    if(form.$valid) {
      console.log('Validating the email....');
      this.$http.post('/api/users/forgotPassword', {
        email: this.user.email
      })
        .then((response)=> {
          console.log('Email has been validated');
          form.email.success = true;
          this.response = response.data.message;

          this.$timeout( () => {
            console.log('here');
            this.$state.go('procedureStatus');
          }, 1000);

        })
        .catch((error)=> {
          form.email.$error.email = true;
          this.errors.email = error.data;
        })
    }
  }
}



// WEBPACK FOOTER //
// ./client/app/account/login/login.controller.js